import { render, staticRenderFns } from "./food-info.vue?vue&type=template&id=22d0a6f6&scoped=true&"
import script from "./food-info.vue?vue&type=script&lang=js&"
export * from "./food-info.vue?vue&type=script&lang=js&"
import style0 from "./food-info.vue?vue&type=style&index=0&id=22d0a6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0a6f6",
  null
  
)

export default component.exports